import React from "react";
import ReactDOM from "react-dom";
import "./scss/index.scss";
import "./scss/map.scss";
import App from "./App";
import { applyMiddleware, combineReducers, createStore } from "redux";
import { Provider } from "react-redux";
import * as serviceWorker from "./serviceWorker";
import * as Reducers from "./flex/Reducers";
import { connection } from "./flex/middleware";
import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";
import { SnackbarProvider } from "notistack";

// グローバルエラーハンドリング（WebViewデバッグ用）
window.onerror = function (message, source, lineno, colno, error) {
  const errorDiv = document.createElement("div");
  errorDiv.style.cssText =
    "position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(255,0,0,0.8);color:white;z-index:99999;overflow:auto;padding:20px;font-size:14px;";
  errorDiv.innerHTML = `<h3>Global Error</h3><p>${message}</p><p>${source}:${lineno}:${colno}</p><pre>${
    error ? error.stack : ""
  }</pre>`;
  document.body.appendChild(errorDiv);
  return false;
};

window.onunhandledrejection = function (event) {
  const errorDiv = document.createElement("div");
  errorDiv.style.cssText =
    "position:fixed;top:50%;left:0;width:100%;height:50%;background:rgba(0,0,0,0.8);color:yellow;z-index:99999;overflow:auto;padding:20px;font-size:14px;";
  errorDiv.innerHTML = `<h3>Unhandled Rejection</h3><p>${event.reason}</p>`;
  document.body.appendChild(errorDiv);
};

const rootReducer = combineReducers({
  ...Reducers,
});
const store = createStore(rootReducer, applyMiddleware(connection));

process.env.NODE_ENV !== "development" && (console.log = () => {});

const theme = createMuiTheme({
  palette: {
    type: "light",
    primary: {
      main: "#0277bd",
    },
    secondary: {
      main: "#ffffff",
    },
  },
});

ReactDOM.render(
  <Provider store={store}>
    <ThemeProvider theme={theme}>
      <SnackbarProvider
        maxSnack={2}
        preventDuplicate
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <App />
      </SnackbarProvider>
    </ThemeProvider>
  </Provider>,
  document.getElementById("root"),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
